import { StarRating } from "@components";
import { Avatar } from "@components/common/Avatar";
import clsx from "clsx";
import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import styles from "./style/ReviewComment.module.css";
import moment from "moment";
import { OverlayTrigger, Placeholder, Spinner, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const ReviewCommentPlaceHolder = () => {
  return (
    <Placeholder
      animation="glow"
      className={clsx(
        "container-fluid p-3 d-flex flex-column rounded",
        styles.container
      )}
    >
      <div className="d-flex">
        <Avatar src={null} width={48} />
        <div className="ml-4 w-100">
          <div>
            <Placeholder xs={2} />
          </div>
          <div>
            <Placeholder xs={2} />
          </div>
        </div>
      </div>
      <Placeholder xs={6} />
      <Placeholder xs={12} />
    </Placeholder>
  );
};

const ReviewComment = forwardRef((props, ref) => {
  const {
    enrollment,
    createdAt,
    rating,
    content,
    editable,
    onEdit,
    className,
    isLoading,
  } = props;
  const { user, courses } = enrollment;
  const navigate = useNavigate();

  const time = moment(createdAt).add(7, "hours").fromNow();

  const handleClickCourse = (e) => {
    e.preventDefault();
    navigate(`/course/${courses.id}#reviews`);
  };

  return (
    <div
      className={clsx(
        "container-fluid p-3 d-flex flex-column rounded",
        styles.container,
        className
      )}
      ref={ref}
    >
      {courses && (
        <div className={styles.courseTitle}>
          <Link to="#" onClick={handleClickCourse}>
            {courses.title}
          </Link>
        </div>
      )}
      <div className="d-flex justify-content-between">
        <div className="d-flex">
          <Avatar src={user.avatarUrl} width={48} />
          <div className="pl-2">
            <p className="mb-1">
              <b>{user.fullName || "Unknown name"}</b>
            </p>
            <p className="text-secondary m-0">{time}</p>
          </div>
        </div>
        <div>
          {editable && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Edit your review</Tooltip>}
            >
              <button className={styles.btnEdit} onClick={() => onEdit()}>
                <i className="bi bi-pencil-square"></i>
              </button>
            </OverlayTrigger>
          )}
          {isLoading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className={styles.loading}
            />
          )}
        </div>
      </div>
      <StarRating numRating={rating} />
      <p className="text-secondary m-0">{content}</p>
    </div>
  );
});

/* required: display name */
ReviewComment.displayName = "ReviewComment";

/* required: props types */
ReviewComment.propTypes = {
  userAvata: PropTypes.string,
  userName: PropTypes.string,
  lastTimeOnline: PropTypes.number,
  numRating: PropTypes.number,
  comment: PropTypes.string,
  editable: PropTypes.bool,
  isLoading: PropTypes.bool,
  onEdit: PropTypes.func,
  className: PropTypes.string,
};

/* required: default props */
ReviewComment.defaultProps = { editable: false, isLoading: false };

export { ReviewComment, ReviewCommentPlaceHolder };
